import { render, staticRenderFns } from "./IpsTelInput.vue?vue&type=template&id=9a408d86"
import script from "./IpsTelInput.vue?vue&type=script&lang=js"
export * from "./IpsTelInput.vue?vue&type=script&lang=js"
import style0 from "./IpsTelInput.vue?vue&type=style&index=0&id=9a408d86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports